var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMorocco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b33431",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#286038",
    d: "M19.22 17.87 15 14.8l-4.22 3.07 1.6-4.97-4.21-3.07h5.22l1.6-4.96 1.62 4.96h5.22l-4.22 3.07zm-3.45-3.63 1.74 1.27-.67-2.05zm-2.61-.78-.67 2.05 1.74-1.27zm.29-.9L15 13.69l1.55-1.13-.6-1.82h-1.9zm3.46-1.82.4 1.26 1.75-1.26zm-5.97 0L12.68 12l.41-1.26zm3.4-.9h1.32L15 7.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorocco);
export default __webpack_public_path__ + "static/media/morocco.104485f59829bed3be1490f60083b287.svg";
export { ForwardRef as ReactComponent };